import { Component, HostBinding, OnInit } from '@angular/core';
import { select } from '@angular-redux/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DataHandlerService } from 'src/app/Services/data-handler.service';
import { LanguageService } from 'src/app/Services/language.service';
import { TranslationService } from 'src/app/Services/translation.service';
import { MainService } from 'src/app/Services/main.service';
import { ILanguageData } from 'src/app/Models/ILanguageData';
import { IHelpResponseData } from 'src/app/Models/IHelpAlertData';
import { ThemeOptions } from '../../../theme-options';
import { LANGUAGE_KEY } from 'src/app/Constants/main-keys';
import { LANGUAGE_PATH_KEY } from 'src/app/Constants/request-path-keys';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  languages: Array<ILanguageData> = [];
  currentLanguageIsoCode: string;

  constructor(
    public globals: ThemeOptions,
    private dataHandlerService: DataHandlerService,
    private languageService: LanguageService,
    private route: ActivatedRoute,
    private router: Router,
    private translationService: TranslationService,
    private mainService: MainService
  ) {
  }

  ngOnInit() {
    this.getLanguages();
    this.currentLanguageIsoCode = this.languageService.currentLanguage;
  }

  async getLanguages() {
    this.languages = await this.dataHandlerService.getData(LANGUAGE_PATH_KEY);
  }

  @HostBinding('class.isActive')
  get isActiveAsGetter() {
    return this.isActive;
  }

  isActive: boolean;

  @select('config') public config$: Observable<any>;

  toggleSidebarMobile() {
    this.globals.toggleSidebarMobile = !this.globals.toggleSidebarMobile;
  }

  toggleHeaderMobile() {
    this.globals.toggleHeaderMobile = !this.globals.toggleHeaderMobile;
  }

  setLanguage(isocode: string): void {
    this.languageService.setLanguage(LANGUAGE_KEY, isocode);
    const currentLanguage = this.languageService.currentLanguage;
    this.currentLanguageIsoCode = this.languageService.currentLanguage;
    const str = this.route.snapshot['_routerState']['url'].toString();
    const changedPath = str.substr(0, 1) + currentLanguage.toString() + str.substr(1 + currentLanguage.toString().length);
    if (currentLanguage) {
      this.router.navigate([changedPath]);
    }
    this.translationService.languageChange.next();
  }

  userHelp(): void {
    const content: Array<IHelpResponseData> = [
      {
        selector: 'create-btn',
        text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum",
        seconds: 5,
        displayOrder: 1,
        startTime: 0,
        timeout: null
      },
      {
        selector: 'edit-btn',
        text: "Lorem Ipsum is simply dummy text ",
        seconds: 6,
        displayOrder: 2,
        startTime: 0,
        timeout: null
      },
      {
        selector: 'filter-btn',
        text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum",
        seconds: 7,
        displayOrder: 3,
        startTime: 0,
        timeout: null
      },
      {
        selector: 'message-checkbox',
        text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum",
        seconds: 5,
        displayOrder: 4,
        startTime: 0,
        timeout: null
      },
    ];
    content.sort((first, second) => first.displayOrder - second.displayOrder);
    content.forEach((item, index) => {
      if(index === 0) {
        item.startTime = 0;
      }
      else {
        item.startTime = content[index - 1].startTime + content[index - 1].seconds;
      }
    });
    this.mainService.setHelpData(content);
  }

}
